import React from 'react';

import { Select, SelectProps, Tooltip, useMantineTheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ResourceType, SyncFrequency } from 'shared/interfaces/Resource';
import { isSyncResourceType } from 'shared/utils/resource';

interface SyncFrequencySelectProps extends SelectProps {
  defaultSyncFrequency: SyncFrequency;
  resourceType: ResourceType;
  couldSync?: boolean;
}

export function SyncFrequencySelect({
  defaultSyncFrequency,
  resourceType,
  couldSync = false,
  ...selectItemProps
}: SyncFrequencySelectProps) {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Tooltip
      label={t('BATCH_RESOURCE_SELECTOR.SYNC.UPGRADE_ACCOUNT_INFO')}
      position="left-start"
      disabled={couldSync}
      events={{ hover: true, focus: false, touch: false }}>
      <Select
        disabled={!isSyncResourceType(resourceType) || !couldSync}
        defaultValue={defaultSyncFrequency}
        styles={{
          input: {
            borderColor: theme.colors.gray[3]
          }
        }}
        maxDropdownHeight={300}
        size="sm"
        variant="default"
        placeholder={t('RESOURCE_TILE.SYNC.DEFAULT_PLACEHOLDER')}
        {...selectItemProps}
      />
    </Tooltip>
  );
}
